import { jsPDF } from "jspdf";
import logoUrl from "../assets/logonew.png";
import heeboTtfUrl from "../assets/fonts/Heebo-Regular.ttf"; // <-- שים פה את ה-ttf

// ממיר URL ל-DataURL (תמונה)
async function urlToDataURL(url) {
  const res = await fetch(url);
  if (!res.ok) throw new Error("Failed to fetch image: " + url);
  const blob = await res.blob();

  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result); // data:image/png;base64,...
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}


const formatIsoDateToIL = (isoDate) => {
  if (!isoDate) return "";

  // לוקחים רק את חלק התאריך
  // "1958-04-20T22:00:00.000+00:00" -> "1958-04-20"
  const datePart = isoDate.split("T")[0];

  const [yyyy, mm, dd] = datePart.split("-");

  return `${dd}/${mm}/${yyyy}`;
};

const textLTR = (pdf, text, x, y, options = {}) => {
  pdf.setR2L(false);
  pdf.text(String(text), x, y, options);
  pdf.setR2L(true);
};
const formatFullDateToIL = (fullDate) => {
  if (!fullDate) return "";

  // "2025-12-25 00:00" → "2025-12-25"
  const [datePart] = fullDate.split(" ");

  const [yyyy, mm, dd] = datePart.split("-");

  const dateStr = `${dd}/${mm}/${yyyy}`;

  // מונע היפוך ב-RTL
  return `\u2066${dateStr}\u2069`;
};
// ✅ טוען פונט TTF לתוך jsPDF (VFS)
async function loadTtfFont(pdf, fontUrl, fontName = "Heebo") {
  const res = await fetch(fontUrl);
  if (!res.ok) throw new Error("Failed to fetch font: " + fontUrl);

  const buffer = await res.arrayBuffer();
  const bytes = new Uint8Array(buffer);

  // ArrayBuffer -> base64
  let binary = "";
  for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i]);
  const base64 = btoa(binary);

  pdf.addFileToVFS(`${fontName}.ttf`, base64);
  pdf.addFont(`${fontName}.ttf`, fontName, "normal");
}

// כתיבת פסקה RTL עם ירידת שורות (בלי reverseText)
function writeParagraphRTL(pdf, text, xRight, y, maxWidth, lineHeight = 6) {
  const split = pdf.splitTextToSize(text, maxWidth);
  pdf.text(split, xRight, y, { align: "right" });
  return y + split.length * lineHeight;
}

export async function createMembershipPdfSingle (pdfData) {
  console.log("Creating PDF with data:", pdfData);
  const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });

  // ✅ 1) טען פונט עברי אמיתי לתוך ה-PDF
  await loadTtfFont(pdf, heeboTtfUrl, "Heebo");
  pdf.setFont("Heebo", "normal");

  // ✅ 2) הפעל RTL אמיתי (במקום reverseText)
  pdf.setR2L(true);

  pdf.setFontSize(12);

  const pageW = pdf.internal.pageSize.getWidth();
  const marginR = 15;
  const marginL = 15;
  const contentW = pageW - marginL - marginR;

  // ===== HEADER סגול =====
  const headerH = 32;
  pdf.setFillColor(86, 60, 120);
  pdf.rect(0, 0, pageW, headerH, "F");

  // לוגו שמאל
  const logoDataUrl = await urlToDataURL(logoUrl);
  const logoSize = 22;
  const logoX = 10;
  const logoY = (headerH - logoSize) / 2;
  pdf.addImage(logoDataUrl, "PNG", logoX, logoY, logoSize, logoSize);

  // כותרת לבנה על הפס
  pdf.setTextColor(255, 255, 255);
  pdf.setFontSize(14);
  pdf.text("טופס הצטרפות כחבר/ה", pageW / 2, 12, { align: "center" });
  pdf.text("ללשכת הממונים על הבטיחות בישראל", pageW / 2, 19, { align: "center" });
  pdf.text("כארגון היציג של הממונים על הבטיחות בישראל", pageW / 2, 26, { align: "center" });

  // תוכן
  pdf.setTextColor(0, 0, 0);
  pdf.setFontSize(11);

  let y = headerH + 12;

  // תת כותרת
  pdf.setFontSize(12);
  y = writeParagraphRTL(
    pdf,
    'אני מצהיר/ה בזאת שברצוני להצטרף כחבר/ה ללשכת הממונים על הבטיחות בישראל )להלן: "הלשכה"(',
    pageW - marginR,
    y,
    contentW,
    6
  );

  // פסקה
  pdf.setFontSize(11);
  y += 2;
  y = writeParagraphRTL(
    pdf,
    "שמטרותיה מפורטות להלן.\n" +
    "אני מתחייב/ת לציית להוראות תקנון הלשכה ולהחלטות המתקבלות מעת לעת על ידי מוסדותיה המוסמכים.\n" +
    "אני מודע/ת לכך שהחברות בלשכה כרוכה בתשלום דמי חבר שנתיים, בסכום, במועד ובתנאים שייקבעו על ידי מוסדותיה המוסמכים של הלשכה מעת לעת.",
    pageW - marginR,
    y,
    contentW,
    6
  );

  y += 6;
  pdf.setFontSize(12);
  y = writeParagraphRTL(pdf, "ידוע לי שמטרות הלשכה הן:", pageW - marginR, y, contentW, 6);

  pdf.setFontSize(11);
  y += 3;
  y = writeParagraphRTL(pdf, "1. להיות ארגון העובדים היציג של הממונים על הבטיחות בישראל.", pageW - marginR, y, contentW, 6);
  y = writeParagraphRTL(
    pdf,
    "2. לפעול לשיפור תנאי העסקתם ושכרם של הממונים על הבטיחות בישראל באמצעות משא ומתן קיבוצי וחתימה על הסכם קיבוצי.",
    pageW - marginR,
    y + 2,
    contentW,
    6
  );
  y = writeParagraphRTL(
    pdf,
    "3. לפעול למען רווחתם ושיפור מעמדם של הממונים על הבטיחות בישראל, באמצעות קידום חקיקה ורגולציה, ניהול מאבקים ציבוריים ו/או משפטיים, ו/או בכל דרך אחרת, על פי כל דין.",
    pageW - marginR,
    y + 2,
    contentW,
    6
  );
  // ====== במקום עמוד 2: מציירים את הטופס בעמוד הראשון ======

  // נקודת התחלה לטופס (מתחת לטקסט של מטרות הלשכה)
  // אם אתה רוצה שזה יהיה תמיד באותו מקום קבוע, אפשר לקבע מספר במקום y.
  const formTopGap = 10;
  let formYStart = y + formTopGap;

  // אם יצא נמוך מדי בדף, תדחוף אותו למעלה (כדי שלא ירד למטה מדי)
  // אפשר לשנות את 150 לפי כמה טקסט יש לך למעלה.
  formYStart = Math.min(formYStart, 150);

  // ===== מסגרת סגולה =====
  const boxMarginX = 12;
  const boxY = formYStart;
  const boxW = pageW - boxMarginX * 2;

  // גובה המלבן — תגדיל/תקטין לפי הצורך כדי שכל השדות ייכנסו
  const boxH = 115;

  pdf.setDrawColor(86, 60, 120);
  pdf.setLineWidth(1.2);
  pdf.rect(boxMarginX, boxY, boxW, boxH);

  // חזרה לקווים שחורים לשדות
  pdf.setDrawColor(0, 0, 0);
  pdf.setLineWidth(0.2);
  pdf.setTextColor(0, 0, 0);
  pdf.setFont("Heebo", "normal");
  pdf.setFontSize(10);

  // גבולות המלבן (כדי שלא נצא החוצה)
  const boxTop = boxY;
  const boxBottom = boxY + boxH;
  const insidePaddingTop = 10;
  const insidePaddingBottom = 8;

  // עוגן כתיבה מימין
  const xRight = boxMarginX + boxW - 4;
  let fy = boxTop + insidePaddingTop;

  // פונקציות עזר
  const drawUnderline = (xRight, yLine, w) => {
    pdf.line(xRight - w, yLine, xRight, yLine);
  };

  const drawLabeledLineRTL = ({
    value,
    label,
    xRight,
    yTop,
    lineW,
    fontSize = 10,
    lineGap = 5,
    type = 0, // 0=RTL , 1=LTR
  }) => {
    pdf.setFontSize(fontSize);
    pdf.text(label, xRight, yTop + lineGap, { align: "right" });
    drawUnderline(xRight, yTop, lineW);
    if (value) {
      if (type == 0) {
        pdf.setFontSize(fontSize);
        pdf.text(
          value,
          xRight - 1,        // טיפה שמאלה כדי שלא ייגע בקצה
          yTop - 1.5,       // טיפה מעל הקו
          { align: "right" }
        );
      }
      else if (type == 1) {
        textLTR(pdf,
          value,
          xRight - 1,        // טיפה שמאלה כדי שלא ייגע בקצה
          yTop - 1.5,       // טיפה מעל הקו
          { align: "right" }
        );
      }
    };
  }

  // const drawCheckboxWithLabelRTL = ({
  //   label,
  //   xRight,
  //   y,
  //   boxSize = 4,
  //   gap = 2,
  // }) => {
  //   pdf.rect(xRight - boxSize, y - boxSize + 1, boxSize, boxSize);
  //   pdf.text(label, xRight - boxSize - gap, y, { align: "right" });
  // };

  const drawCheckboxWithLabelRTL = ({
  label,
  xRight,
  y,
  checked = false, // 👈 חדש
  boxSize = 4,
  gap = 2,
}) => {
  // ריבוע
  const boxX = xRight - boxSize;
  const boxY = y - boxSize + 1;
  pdf.rect(boxX, boxY, boxSize, boxSize);

  // טקסט
  pdf.text(label, xRight - boxSize - gap, y, { align: "right" });

  // אם מסומן – מציירים X
  if (checked) {
    pdf.setLineWidth(0.6);

    pdf.line(
      boxX + 0.6,
      boxY + 0.6,
      boxX + boxSize - 0.6,
      boxY + boxSize - 0.6
    );

    pdf.line(
      boxX + boxSize - 0.6,
      boxY + 0.6,
      boxX + 0.6,
      boxY + boxSize - 0.6
    );

    pdf.setLineWidth(0.2); // מחזיר עובי רגיל
  }
};

  // אם אתה רוצה להיות בטוח שלא תצא מהמלבן:
  const assertInsideBox = (nextYNeeded) => {
    if (nextYNeeded > boxBottom - insidePaddingBottom) {
      // פתרון מהיר: או להקטין רווחים/פונט, או להגדיל boxH
      // כרגע פשוט נקטין קצת את המרווחים אוטומטית:
      // (אם עדיין לא מספיק — תגדיל boxH למעלה)
    }
  };

  // ===== כותרת בתוך המלבן =====
  pdf.setFontSize(11);
  pdf.text("פרטי הממונה:", xRight, fy, { align: "right" });

  // ===== שורה 1 =====
  fy += 10;
  assertInsideBox(fy + 10);

  const wShort = 32;
  const wMed = 40;

  drawLabeledLineRTL({ label: "שם פרטי", value: pdfData?.fillFirstName, xRight, yTop: fy, lineW: wMed });

  const x2 = xRight - (wMed + 11);
  drawLabeledLineRTL({ label: "שם משפחה", value: pdfData?.fillLastName, xRight: x2, yTop: fy, lineW: wMed });

  const x3 = x2 - (wMed + 11);
  drawLabeledLineRTL({ label: "ת.ז", value: pdfData?.identityNumber, xRight: x3, yTop: fy, lineW: wShort, type: 1 });

  const x4 = x3 - (wShort + 11);
  drawLabeledLineRTL({ label: "מס' סידורי", value: pdfData?.documentIndex, xRight: x4, yTop: fy, lineW: wShort, type: 1 });

  // ===== שורה 2 =====
  fy += 18;
  assertInsideBox(fy + 10);

  drawLabeledLineRTL({ label: "תאריך לידה", value: formatIsoDateToIL(pdfData?.dataBorn), xRight, yTop: fy, lineW: wMed , type: 1});

  const xSex = xRight - (wMed + 11);
  drawLabeledLineRTL({ label: "מין: זכר / נקבה", value: pdfData?.gender, xRight: xSex, yTop: fy, lineW: wShort });
  // ===== שורה 3 =====
  fy += 18;
  assertInsideBox(fy + 10);

  drawLabeledLineRTL({ label: "כתובת מגורים:", value: pdfData?.street, xRight, yTop: fy, lineW: 80 });

  const xCity = xRight - (80 + 15);
  drawLabeledLineRTL({ label: "עיר", value: pdfData?.city, xRight: xCity, yTop: fy, lineW: 70 });

  // ===== שורה 4: צ׳קבוקסים =====
  fy += 18;
  assertInsideBox(fy + 10);

  pdf.setFontSize(10);
  pdf.text("בחר את האפשרות הנכונה לעיל:", xRight, fy, { align: "right" });

  const xChecks = xRight - 50;
  drawCheckboxWithLabelRTL({ label: "שכיר", xRight: xChecks, y: fy, checked: pdfData?.job === "שכיר" });
  drawCheckboxWithLabelRTL({ label: "עצמאי", xRight: xChecks - 15, y: fy , checked: pdfData?.job === "עצמאי" });

  // ===== שורה 5 =====
  fy += 14;
  assertInsideBox(fy + 10);

  drawLabeledLineRTL({
    label: "שם המעסיק )אם עצמאי, כתוב 'עצמאי'(:",
    value: pdfData?.employerName,
    xRight,
    yTop: fy,
    lineW: 150,
  });

  // ===== שורה 6 =====
  fy += 18;
  assertInsideBox(fy + 10);

  drawLabeledLineRTL({
    label: "כתובת מקום העבודה )אם עצמאי, כתוב כתובת מגורים(:",
    value: pdfData?.placeJob,
    xRight,
    yTop: fy,
    lineW: 165,
  });

  // // ===== עמוד 2 =====
  // pdf.addPage();
  // pdf.setFont("Heebo", "normal");
  // pdf.setR2L(true);
  // pdf.setTextColor(0, 0, 0);

  // const pageW2 = pdf.internal.pageSize.getWidth();

  // // עזר לשדות
  // const drawUnderline = (xRight, yLine, w) => pdf.line(xRight - w, yLine, xRight, yLine);

  // const drawLabeledLineRTL = ({ label, xRight, yTop, lineW, fontSize = 10, lineGap = 5 }) => {
  //   pdf.setFontSize(fontSize);
  //   pdf.text(label, xRight, yTop, { align: "right" });
  //   drawUnderline(xRight, yTop + lineGap, lineW);
  // };

  // const drawCheckboxWithLabelRTL = ({ label, xRight, y, boxSize = 4, gap = 2 }) => {
  //   pdf.rect(xRight - boxSize, y - boxSize + 1, boxSize, boxSize);
  //   pdf.text(label, xRight - boxSize - gap, y, { align: "right" });
  // };

  // // מסגרת סגולה
  // const boxMarginX = 12;
  // const boxY = 18;
  // const boxW = pageW2 - boxMarginX * 2;
  // const boxH = 105;

  // pdf.setDrawColor(86, 60, 120);
  // pdf.setLineWidth(1.2);
  // pdf.rect(boxMarginX, boxY, boxW, boxH);

  // pdf.setDrawColor(0, 0, 0);
  // pdf.setLineWidth(0.2);

  // const xRight = boxMarginX + boxW - 10;
  // y = boxY + 12;

  // pdf.setFontSize(11);
  // pdf.text("פרטי הממונה:", xRight, y, { align: "right" });

  // y += 10;

  // const wShort = 32;
  // const wMed = 50;

  // drawLabeledLineRTL({ label: "שם פרטי", xRight, yTop: y, lineW: wMed });
  // const x2 = xRight - (wMed + 22);
  // drawLabeledLineRTL({ label: "שם משפחה", xRight: x2, yTop: y, lineW: wMed });
  // const x3 = x2 - (wMed + 22);
  // drawLabeledLineRTL({ label: "ת.ז", xRight: x3, yTop: y, lineW: wShort });
  // const x4 = x3 - (wShort + 22);
  // drawLabeledLineRTL({ label: "מס' סידורי", xRight: x4, yTop: y, lineW: wShort });

  // y += 18;
  // drawLabeledLineRTL({ label: "תאריך לידה", xRight, yTop: y, lineW: wMed });
  // const xSex = xRight - (wMed + 55);
  // drawLabeledLineRTL({ label: "מין: זכר / נקבה", xRight: xSex, yTop: y, lineW: 70 });

  // y += 18;
  // drawLabeledLineRTL({ label: "כתובת מגורים:", xRight, yTop: y, lineW: 110 });
  // const xCity = xRight - (110 + 35);
  // drawLabeledLineRTL({ label: "עיר", xRight: xCity, yTop: y, lineW: 70 });

  // y += 18;
  // pdf.setFontSize(10);
  // pdf.text("בחר את האפשרות הנכונה לעיל:", xRight, y, { align: "right" });

  // const xChecks = xRight - 70;
  // drawCheckboxWithLabelRTL({ label: "שכיר", xRight: xChecks, y });
  // drawCheckboxWithLabelRTL({ label: "עצמאי", xRight: xChecks - 30, y });

  // y += 14;
  // drawLabeledLineRTL({
  //   label: "שם המעסיק (אם עצמאי, כתוב 'עצמאי'):",
  //   xRight,
  //   yTop: y,
  //   lineW: 150,
  // });

  // y += 18;
  // drawLabeledLineRTL({
  //   label: "כתובת מקום העבודה (אם עצמאי, כתוב כתובת מגורים):",
  //   xRight,
  //   yTop: y,
  //   lineW: 165,
  // });
  // =========================
  // ===== דף 2: הצהרה =====
  // =========================
  pdf.addPage();
  pdf.setFont("Heebo", "normal");
  pdf.setR2L(true);
  pdf.setTextColor(0, 0, 0);

  const pageW2 = pdf.internal.pageSize.getWidth();
  const pageH2 = pdf.internal.pageSize.getHeight();

  // מסגרת סגולה (כמו בתמונה)
  const BOX_X = 12;
  const BOX_Y = 18;
  const BOX_W = pageW2 - BOX_X * 2;
  const BOX_H = 60; // גובה הבלוק – אפשר לשנות אם תרצה יותר "אוויר"

  pdf.setDrawColor(86, 60, 120);
  pdf.setLineWidth(1.2);
  pdf.rect(BOX_X, BOX_Y, BOX_W, BOX_H);

  // חזרה לקווים/טקסט שחורים
  pdf.setDrawColor(0, 0, 0);
  pdf.setLineWidth(0.2);
  pdf.setFontSize(10);

  const padX = 10;
  const xRight2 = BOX_X + BOX_W - padX;

  // עזר לצ׳קבוקסים
  // const checkboxRTL = ({ label, xRight, y, boxSize = 4, gap = 2 }) => {
  //   // ריבוע צ׳קבוקס מימין לטקסט (ב-RTL יוצא טבעי)
  //   pdf.rect(xRight - boxSize, y - boxSize + 1, boxSize, boxSize);
  //   pdf.text(label, xRight - boxSize - gap, y, { align: "right" });
  // };
const checkboxRTL = ({
  label,
  xRight,
  y,
  checked = false, // 👈 חדש
  boxSize = 4,
  gap = 2,
}) => {
  const boxX = xRight - boxSize;
  const boxY = y - boxSize + 1;

  // ריבוע
  pdf.rect(boxX, boxY, boxSize, boxSize);

  // טקסט
  pdf.text(label, xRight - boxSize - gap, y, { align: "right" });

  // X אם מסומן
  if (checked) {
    pdf.setLineWidth(0.6);

    pdf.line(
      boxX + 0.6,
      boxY + 0.6,
      boxX + boxSize - 0.6,
      boxY + boxSize - 0.6
    );

    pdf.line(
      boxX + boxSize - 0.6,
      boxY + 0.6,
      boxX + 0.6,
      boxY + boxSize - 0.6
    );

    pdf.setLineWidth(0.2); // חזרה לעובי רגיל
  }
};

  // עזר לשורה להשלמה
  const underlineRTL = (xRight, yLine, w) => {
    pdf.line(xRight - w, yLine, xRight, yLine);
  };

  // עזר לפסקה "צמודה" בתוך המסגרת
  const writeParagraphInBox = (text, yStart, maxWidth, lineHeight = 4.7) => {
    const yEnd = writeParagraphRTL(pdf, text, xRight2, yStart, maxWidth, lineHeight);
    return yEnd;
  };

  // ===== כותרת: "הצהרה:" (בימין עליון)
  let yy = BOX_Y + 10;
  pdf.setFontSize(11);
  pdf.text("הצהרה:", xRight2, yy, { align: "right" });

  // ===== צ׳קבוקס ראשון + טקסט ארוך
  yy += 7;
  pdf.setFontSize(10);

  // נצייר את הצ׳קבוקס בקצה שמאל של השורה (כמו בתמונה – משמאל לטקסט)
  // אנחנו עובדים RTL, אז "שמאל" מבחינתנו זה x קטן יותר.
  const cb1X = BOX_W; // נקודה שמאלית יחסית במסגרת
  const cb1Y = yy;


  checkboxRTL({
    label: 'אני מאשר/ת כי אני זכאי/ת להתמנות כממונה על בטיחות ומחזיק/ה באישור כשירות תקף לפי דין.',
    xRight: xRight2,
    y: yy,
    checked: pdfData?.box1 === true,
  });

  // yy += 2;



  // // צ׳קבוקס ראשון (הריבוע)
  // pdf.rect(xRight2, cb1Y - 3, 4, 4);

  // // טקסט הראשון (יישור לימין בתוך המסגרת)
  // const text1 =
  //   'אני מאשר/ת כי אני זכאי/ת להתמנות כממונה על בטיחות ומחזיק/ה באישור כשירות תקף לפי דין.';
  // // נתחיל את הפסקה מעט מתחת לשורה כדי שיישב יפה ליד הצ׳קבוקס
  // yy = writeParagraphInBox(text1, yy, xRight2-5 , 4.7);

  // ===== כותרת משנה
  yy += 8;
  pdf.setFontSize(10);
  pdf.text("בחר/י את האפשרות הנכונה לגבייך:", xRight2, yy, { align: "right" });

  // ===== שני צ׳קבוקסים (שתי אפשרויות)
  yy += 7;

  // אפשרות ימנית
  checkboxRTL({
    label: "אינני חבר/ה בארגון עובדים אחר.",
    xRight: xRight2,
    y: yy,
    checked: pdfData?.box2 === true,

  });

  // אפשרות שמאלית (כמו בתמונה – בשורה העליונה בצד שמאל)
  // פשוט נזיז את xRight שמאלה
  checkboxRTL({
    label: "אני מודיע/ה בזאת על הפסקת חברותי בארגון אחר.",
    xRight: xRight2 - 70, // כיוונון מיקום
    y: yy,
    checked: pdfData?.box3 === true,

  });

  // ===== פסקה + שורה להשלמה
  yy += 10;
  pdf.setFontSize(10);

  const text2 =
    "אני מאשר/ת ללשכת הממונים על הבטיחות בישראל להעביר הודעה זו לארגון העובדים האחר לצורך ביטול החברות.\n" +
    'כתוב את שם הארגון האחר. )במידה ואת/ה לא חבר בארגון אחר, אנא ענה "אין"(';

  yy = writeParagraphInBox(text2, yy, BOX_W - 20, 4.7);

  pdf.text(pdfData?.otherOrganizationName || "", xRight2-1, yy+0.5, { align: "right" });
  // שורת מילוי ארוכה (קו תחתון)
  // yy += 5;
  underlineRTL(xRight2, yy+1.5, BOX_W - 20);


  // =========================
  // ===== המשך דף 2: חלק אחרון =====
  // =========================

  // yy = המיקום האחרון שבו סיימנו את "הצהרה"
  // אם אצלך הקוד של ההצהרה מסתיים עם yy, תמשיך להשתמש בו.
  // אם לא — פשוט תגדיר yy ידנית (למשל: let yy = BOX_Y + BOX_H + 12;)

  // const pageW = pdf.internal.pageSize.getWidth();
  const pageH = pdf.internal.pageSize.getHeight();

  const marginR2 = 15;
  const marginL2 = 15;
  const contentW2 = pageW - marginL2 - marginR2;

  // אם אין לך yy מהקטע הקודם, תפתח אותו כך:
  // let yy = BOX_Y + BOX_H + 12;

  // תוודא מרווח מהמסגרת של ההצהרה
  yy += 20;

  // אם אין מספיק מקום — פתח דף חדש
  const ensureSpace = (needH) => {
    if (yy + needH > pageH - 25) {
      pdf.addPage();
      pdf.setFont("Heebo", "normal");
      pdf.setR2L(true);
      pdf.setTextColor(0, 0, 0);
      yy = 25;
    }
  };

  // 1) פסקה בולטת
  ensureSpace(28);
  pdf.setFontSize(11);
  // bold אמיתי רק אם יש לך Heebo-Bold; אם אין, נעשה "בולט" ע"י גודל + שכפול
  // אם יש לך Heebo-Bold.ttf ותטען אותו, אפשר pdf.setFont("Heebo","bold")
  const boldText =
    "אני מאשר/ת את נכונות הפרטים לעיל, ומתחייב/ת לעדכן את הלשכה על כל שינוי בפרטים אלו.";
  // בולט: גודל 12 + הדפסה פעמיים בהזזה קטנה
  pdf.setFontSize(12);
  pdf.text(boldText, pageW - marginR2, yy, { align: "right" });
  pdf.text(boldText, pageW - marginR2 + 0.2, yy, { align: "right" }); // “עובי” קטן
  yy += 12;

  // 2) כותרת "העלאת תמונה:"
  ensureSpace(45);
  pdf.setFontSize(11);
  pdf.text("העלאת תמונה:", pageW - marginR2, yy, { align: "right" });
  yy += 6;




  // 3) תיבת תמונה (placeholder)
  const imgBoxW = 50;
  const imgBoxH = 50;
  const imgBoxX = pageW - marginR2 - imgBoxW; // צמוד לימין
  const imgBoxY = yy;



  if (pdfData?.selfImage_url) {
    // const imgData = await urlToFile(`https://archivebureau.s3.eu-west-3.amazonaws.com/${pdfData.selfImage_url}?t=${Date.now()}`, data?.imgFacePicture?.split('/').pop());
    // const imgData = await urlToDataURL(`https://archivebureau.s3.eu-west-3.amazonaws.com/${pdfData.selfImage_url}?t=${Date.now()}`);
    // const imgData = await urlToDataURL(pdfData.selfImage_url);
    const imgData = pdfData.selfImage_url;
    
    // { console.log("imgData:", imgData); }
    pdf.addImage(
      imgData,
      "JPEG", // או PNG
      imgBoxX,
      imgBoxY,
      imgBoxW,
      imgBoxH
    );
  } else {
    // placeholder אם אין תמונה
    pdf.setDrawColor(0, 0, 0);
    pdf.setLineWidth(0.3);
    pdf.rect(imgBoxX, imgBoxY, imgBoxW, imgBoxH);
    pdf.setFontSize(9);
    pdf.text("כאן תופיע תמונה", imgBoxX + imgBoxW / 2, imgBoxY + imgBoxH / 2, {
      align: "center",
    });
  }
  // pdf.setDrawColor(0, 0, 0);
  // pdf.setLineWidth(0.3);
  // pdf.rect(imgBoxX, imgBoxY, imgBoxW, imgBoxH);

  // // טקסט קטן בתוך התיבה (אופציונלי)
  // pdf.setFontSize(9);
  // pdf.text("כאן תופיע תמונה", imgBoxX + imgBoxW / 2, imgBoxY + imgBoxH / 2, { align: "center" });

  yy += imgBoxH + 30;

  // 4) תאריך + חתימה (קווים)
  ensureSpace(20);

  pdf.setFontSize(10);

  const lineW = 70;
  const gapBetween = 25;

  // תאריך (ימין)
  const dateXRight = pageW - marginR2;
  pdf.text("תאריך:", dateXRight, yy, { align: "right" });
  pdf.line(dateXRight - lineW, yy + 4, dateXRight, yy + 4);
  //   if (pdfData?.fullDate) {
  //      pdf.setR2L(false);
  //   pdf.text(
  //     formatFullDateToIL(pdfData?.fullDate),
  //     dateXRight - 7,
  //     yy, // מעט מעל הקו
  //     { align: "right" }
  //   );
  // }
  // pdf.setR2L(true);
  textLTR(pdf, formatFullDateToIL(pdfData?.fullDate), dateXRight - 7, yy, { align: "right" });

  // חתימה (שמאל מהתאריך)
  const signXRight = dateXRight - (lineW + gapBetween);
  pdf.text("חתימה:", signXRight, yy, { align: "right" });
  pdf.line(signXRight - lineW, yy + 4, signXRight, yy + 4);

if (pdfData?.signatureImage_url) {
  const sigData = pdfData.signatureImage_url;
  // const sigData = 
  //  await urlToDataURL(`https://archivebureau.s3.eu-west-3.amazonaws.com/${pdfData?.signatureImage_url}?t=${Date.now()}`);

  // מיקום: בתוך הריבוע של הקו
  const sigW = lineW;     // רוחב חתימה כמו הקו
  const sigH = 14;        // גובה חתימה (תשחק 10-18 לפי מה שנראה טוב)

  const sigX = signXRight - sigW; // מתחיל משמאל ומסתיים ב-signXRight
  const sigY = (yy + 4) - sigH;   // “יושב” מעל הקו

  // PNG הכי נפוץ לחתימות (רקע שקוף)
  pdf.addImage(sigData, "PNG", sigX, sigY, sigW, sigH);
}



  yy += 30;

  // 5) משפט סיום במרכז תחתון של העמוד
  // נניח אותו קבוע ליד תחתית הדף כדי שייראה יפה תמיד
  const footerText = "ביחד נעשה ונצליח\nלשכת הממונים על הבטיחות בישראל";
  pdf.setFontSize(12);

  // נמדוד גובה משוער
  const footerY = yy
  pdf.text(footerText, pageW / 2, footerY, { align: "center" });

  // pdf.save("membership-form.pdf");
  return pdf;
}
